/*
    公共数据
*/

const configData = {
    NODE_ENV: process.env.API_ENV,
};

export default configData;





// WEBPACK FOOTER //
// ./src/utils/config-data/config-data.js